var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg404(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.7335 39.3587C57.0875 34.5005 44.6055 32 32 32V128.671C32 141.366 34.4828 152.594 39.3067 164.323C44.1306 176.052 51.2011 186.709 60.1146 195.686C69.028 204.662 79.6098 211.783 91.2557 216.641C102.902 221.5 115.384 224 127.989 224C140.595 224 153.077 221.5 164.723 216.641C168.602 215.023 172.363 213.154 175.983 211.049C168.78 206.86 162.087 201.712 156.104 195.686C138.102 177.556 127.989 154.31 127.989 128.671C127.989 115.976 125.506 103.406 120.682 91.6768C115.859 79.9481 108.788 69.2912 99.8746 60.3144C90.9612 51.3376 80.3794 44.2169 68.7335 39.3587Z",
    fill: "#7E5AE2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M223.978 127.329C224.027 126.529 223.978 125.724 223.978 124.912C223.978 103.556 206.788 86.2434 185.583 86.2434C164.377 86.2434 147.187 103.556 147.187 124.912C147.187 125.724 147.138 126.529 147.187 127.329C147.187 147.84 155.277 167.511 169.679 182.014C176.532 188.916 184.547 194.379 193.262 198.209C194.144 197.385 195.011 196.544 195.864 195.686C204.777 186.709 211.848 176.052 216.672 164.323C221.495 152.595 223.978 140.024 223.978 127.329Z",
    fill: "#7E5AE2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.088aea917c05033ade2a41e2c196aff0.svg";
export { ForwardRef as ReactComponent };